import { render, staticRenderFns } from "./DesignSystemDocs.vue?vue&type=template&id=c23fb8b6&scoped=true&lang=pug&"
import script from "./DesignSystemDocs.vue?vue&type=script&lang=js&"
export * from "./DesignSystemDocs.vue?vue&type=script&lang=js&"
import style0 from "./DesignSystemDocs.vue?vue&type=style&index=0&id=c23fb8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23fb8b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
